<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">PROJETO - ETAPA</span>
            </b-card-header>
            <b-card-body>
                <etapa-detalhar
                    :projeto="projeto"
                    :etapa="etapa"
                ></etapa-detalhar>
            </b-card-body>
            <b-card-footer>
                <slot name="etapaFooter"></slot>
            </b-card-footer>
        </b-card>
        <b-card no-body>
            <b-card-header>
                <span class="h5">DESPESAS</span>
            </b-card-header>
            <b-card-body>
                <despesas
                    :despesas="despesas"
                    :servicos="servicos"
                    :permiteAtualizarCentroCusto="permiteAtualizarCentroCusto"
                    :permiteExcluirComprometimento="permiteExcluirComprometimento"
                    :temPagamento="true"
                    :permiteAcessoErroComprometimento="permiteAcessoErroComprometimento"
                    @recarregarDespesas="$emit('recarregarDespesas')"
                >
                    <template slot="despesaAcoes" slot-scope="data">
                        <slot name="despesaAcoes" v-bind="data"></slot>
                    </template>
                </despesas>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import EtapaDetalhar from './EtapaDetalhar';
import Despesas from '../despesas/Despesas';
import BtnToDocumentacao from './BtnToDocumentacao';

export default {
    components: {
        EtapaDetalhar,
        Despesas,
        BtnToDocumentacao
    },

    props: {
        projeto: {
            type: Object,
            default: () => ({})
        },
        
        etapa: {
            type: Object,
            default: () => ({})
        },

        despesas: {
            type: Array,
            default: () => []
        },

        servicos: {
            type: Object,
            default: () => ({})
        },

        permiteAtualizarCentroCusto: {
            type: Boolean,
            default: false
        },

        permiteExcluirComprometimento: {
           type: Boolean,
           default: false 
        },

        permiteAcessoErroComprometimento: {
           type: Boolean,
           default: false 
        }
    },

    computed: {
        temDocumento() {
            return this.etapa != null && this.etapa.urlDocumentacaoValidacao != null
        }
    },

    methods: {
    }
}

</script>